import Blog from './blog'

export default Blog